import { useState } from "react";
import { contactChannels } from "@/mocks/homeData";

export default function ContactSection() {
  const [copied, setCopied] = useState("");

  const handleCopy = async (email: string) => {
    try {
      await navigator.clipboard.writeText(email);
    } catch {
      setCopied(email);
      window.setTimeout(() => setCopied(""), 1800);
      return;
    }
    setCopied(email);
    window.setTimeout(() => setCopied(""), 1800);
  };

  return (
    <section id="contact" className="w-full bg-secondary-50 border-y border-secondary-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <div className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full">
              <i className="ri-mail-send-line"></i>
              <span>官方联系方式</span>
            </div>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold tracking-tight text-foreground-950">
              直接联系黑料官方
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              四类邮箱各管一件事，按需求选对应的那个，回复会更快。
              所有地址都可以一键复制，粘贴到你的邮箱就能用。
            </p>

            <div className="mt-6 rounded-lg border border-secondary-200 bg-background-50 p-5">
              <div className="flex items-center gap-2 text-sm font-medium text-foreground-900">
                <i className="ri-time-line text-secondary-600"></i>
                服务时间与响应
              </div>
              <ul className="mt-3 space-y-2 text-xs md:text-sm text-foreground-600">
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-accent-600"></i>
                  在线客服：工作日 7×24 小时
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-accent-600"></i>
                  邮箱投稿：全天候接收，24 小时内回执
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-accent-600"></i>
                  违规举报：核实后优先处理
                </li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {contactChannels.map((item) => (
              <div
                key={item.email}
                className="flex flex-col rounded-lg border border-secondary-200 bg-background-50 p-5 md:p-6 hover:border-secondary-400 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <span className="w-11 h-11 md:w-12 md:h-12 rounded-lg bg-secondary-500 text-background-50 flex items-center justify-center text-xl">
                    <i className={item.icon}></i>
                  </span>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{item.type}</h3>
                </div>

                <p className="mt-3.5 text-xs md:text-sm leading-relaxed text-foreground-600 flex-1">{item.note}</p>

                <div className="mt-4 rounded-md bg-background-100 border border-background-200/70 px-3.5 py-2.5">
                  <span className="block text-xs text-foreground-500">{item.hours}</span>
                  <div className="mt-1 flex items-center justify-between gap-3">
                    <span className="text-xs md:text-sm font-medium text-foreground-900 truncate">
                      {item.email}
                    </span>
                    <button
                      type="button"
                      onClick={() => handleCopy(item.email)}
                      className="shrink-0 inline-flex items-center gap-1 text-xs font-medium text-primary-700 hover:text-primary-800 whitespace-nowrap cursor-pointer"
                    >
                      <i className={copied === item.email ? "ri-check-line" : "ri-file-copy-line"}></i>
                      <span>{copied === item.email ? "已复制" : "复制"}</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}